import React from 'react';
import PropTypes from 'prop-types';
import './MarketplaceOfferContainerManager.scss';
import MarketPlaceCarousel from 'partial/OfferManager/modules/MarketplaceOfferModule/MarketPlaceCarousel';

const MarketplaceOfferContainerManager = props => {
  if (!props.staticModules) return '';
  const renderedModules = props.renderContainer;

  if (props.display === 'inline') {
    return (
      <div className="actionInlineMarketPlaceOfferContainer">
        {renderedModules}
      </div>
    );
  } else {
    return (
      <MarketPlaceCarousel
        isSmallActions={props.isSmallActions}
        pagePosition={props.pagePosition}
        modulePosition={props.modulePosition}
        type={props.type}
        customModuleName={props.customModuleName}
      >
        {renderedModules}
      </MarketPlaceCarousel>
    );
  }
};

MarketplaceOfferContainerManager.propTypes = {
  containerName: PropTypes.string,
  eventHandler: PropTypes.func.isRequired,
  staticModules: PropTypes.object.isRequired,
};

export default MarketplaceOfferContainerManager;
